import {ShowStudentIDType} from '../../../../../types';

export const showStudentIDs = [
	{value: ShowStudentIDType.StudentID, text: 'Student ID'},
	{value: ShowStudentIDType.ExportID, text: 'Export ID'},
];